import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {UiJpatsModule} from "../shared/ui-jpats/ui-jpats.module";
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { LoggedoutComponent } from './loggedout/loggedout.component';

@NgModule({
  imports: [
    CommonModule,
    UiJpatsModule
  ],
  providers:[

  ],
  declarations: [UnauthorizedComponent, LoggedoutComponent]
})
export class LoginModule { }
